import { useEffect } from "react";
import "../styles/Contents.css";

export default function Tuitions() {

  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.isIntersecting
            ? entry.target.classList.add("active")
            : entry.target.classList.remove("active");
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page">
      {/* ================= HERO ================= */}
      <section className="about-hero reveal">
        <h1>Tuition Programs</h1>
        <p>
          Focused evening tuition programs for Classes 1 to 9, and exclusive
          Stay & Study residential coaching for Classes 9 and 10.
        </p>
      </section>

      {/* ================= INTRO ================= */}
      <section className="about-section reveal-left">
        <div>
          <h2>Where Education Is Valued</h2>
          <p>
            The word “Education” comes from the Latin word <strong>educare</strong>,
            meaning to bring out the best from within. Intellectual education
            shapes the mind, while value-based education shapes character.
            Together, they build confident and responsible citizens.
          </p>
        </div>
      </section>

      {/* ================= CLASSES 1–5 ================= */}
      <section className="about-section reveal-left">
        <div>
          <h2>📘 Classes 1 – 5</h2>
          <p>
            Foundational tuition focusing on reading, writing, numeracy, and
            concept clarity in a caring and structured environment.
          </p>
          <p>
            ⏰ <strong>Timings:</strong> 4:30 PM – 7:30 PM
          </p>
          <span className="click-hint">Foundational Learning</span>
        </div>
      </section>

      {/* ================= CLASSES 6–8 ================= */}
      <section className="about-section reveal-right">
        <div>
          <h2>📗 Classes 6 – 8</h2>
          <p>
            Concept-focused tuition covering Mathematics, Science, and core
            subjects with regular assessments and guided problem solving.
          </p>
          <p>
            ⏰ <strong>Timings:</strong> 4:30 PM – 7:30 PM
          </p>
          <span className="click-hint">Build Strong Concepts</span>
        </div>
      </section>

      {/* ================= CLASS 9 ================= */}
      <section className="about-section reveal-left">
        <div>
          <h2>📙 Class 9</h2>
          <p>
            Board-oriented coaching with structured preparation, periodic tests,
            and focused mentoring to prepare students for Class 10 success.
          </p>
          <p>
            ⏰ <strong>Timings:</strong> 4:30 PM – 7:30 PM
          </p>
          <span className="click-hint">Prepare for Boards</span>
        </div>
      </section>

      {/* ================= PROGRAM HIGHLIGHTS ================= */}
      <section className="mission-section reveal">
        <h2>✨ Program Highlights</h2>

        <div className="mission-grid">
          <div className="mission-card">
            <h3>⏰ Fixed Evening Timings</h3>
            <p>Daily tuition from 4:30 PM to 7:30 PM ensures consistency.</p>
          </div>

          <div className="mission-card">
            <h3>👩‍🏫 Experienced Faculty</h3>
            <p>Qualified teachers with individual student attention.</p>
          </div>

          <div className="mission-card">
            <h3>📚 Comprehensive Curriculum</h3>
            <p>Structured programs focused on clarity and fundamentals.</p>
          </div>

          <div className="mission-card">
            <h3>📝 Regular Assessments</h3>
            <p>Weekly tests and progress tracking for steady improvement.</p>
          </div>

          <div className="mission-card">
            <h3>🤝 Parent–Teacher Interaction</h3>
            <p>Transparent feedback and academic discussions.</p>
          </div>

          <div className="mission-card">
            <h3>🎯 Exam-Oriented Training</h3>
            <p>Preparation aligned with school and board examinations.</p>
          </div>
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <section className="about-footer reveal">
        <p>
          ACCESS Tuition and Stay & Study programs are designed to nurture
          discipline, confidence, and academic excellence from an early age.
        </p>
      </section>
    </div>
  );
}
